import config from '@/modules/config/functions/config';
import createBaseWretch from '@/modules/query-client/functions/createBaseWretch';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { match, P } from 'ts-pattern';

const baseUrl = match(config('api.url', 'http://localhost:8000'))
  .with(
    P.when((url) => !url.endsWith('/')),
    (url) => `${url}/`
  )
  .otherwise((url) => url);

export default function usePublicWretch() {
  const { i18n } = useTranslation();

  return useMemo(() => {
    return createBaseWretch(baseUrl)
      .headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Accept-Language': i18n.language,
      })
      .query({
        lang: i18n.language,
      });
  }, [i18n.language]);
}
